var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-ignore
import cloneDeep from 'lodash/cloneDeep';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { connect } from 'react-redux';
import AuthService from '../../classes/auth.service';
import ApiRequests from '../../classes/http/ApiRequests';
import HttpRequests from '../../classes/http/HttpRequests';
import NotosService from '../../classes/notos.service';
import Input from '../../components/UI/Input/Input';
import loginSchema from '../../schemas/loginSchema';
import './UnauthUser.css';
import UnauthUserReduxProps from './UnauthUserReduxProps';
var UnauthUser = /** @class */ (function (_super) {
    __extends(UnauthUser, _super);
    function UnauthUser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.location = '';
        _this.header = null;
        _this.submitButton = null;
        _this.state = {
            formConfig: null,
            formIsValid: false,
        };
        _this.inputChangedHandler = function (event, formElement, eventType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[formElement.id]);
            updatedFormElement.value = event.currentTarget.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[formElement.id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.inputBlurHandler = function (event, id) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            var eventType = 'onBlur';
            updatedFormElement.value = event.target.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.checkFilledInputs = function (formData) {
            // the method also check the auto filled inputs.
            var userNameValid = false;
            var passwordValid = false;
            if (formData.username.value !== '' && formData.password.value !== '') {
                userNameValid = NotosService.checkFieldValidity(formData.username.value, formData.username.validation, 'onBlur');
                passwordValid = NotosService.checkFieldValidity(formData.password.value, formData.password.validation, 'onBlur');
            }
            formData.username.valid = userNameValid;
            formData.password.valid = passwordValid;
            var formValid = NotosService.checkFormValidity(formData);
            if (formValid && userNameValid && passwordValid) {
                return true;
            }
            else {
                _this.setState({ formConfig: formData, formIsValid: formValid });
                return false;
            }
        };
        _this.submitFormHandler = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            if (_this.checkFilledInputs(formData)) {
                _this.props.onShowSpinner();
                _this.loginRequest({
                    email: formData.username.value.trim().toLowerCase(),
                    password: formData.password.value.trim(),
                    '2fa_token': formData['2fa_token'].value.trim().toLowerCase(),
                });
            }
        };
        _this.loginRequest = function (credentials) {
            _this.api
                .login(credentials)
                .then(function (response) {
                AuthService.userLogin(_this.props.history, response.data);
            })
                .catch(function (error) {
                var errorResponse = error.response;
                if (errorResponse.status === 401) {
                    _this.messages.show({ life: 5000, severity: 'error', detail: errorResponse.data.message });
                }
                if (errorResponse.status === 422) {
                    var customErrorMessage = 'Email, парола или код са грешни'; // Your custom error message
                    _this.http.handleError(error, _this.messages, '', _this.props.history, customErrorMessage);
                }
                else {
                    _this.http.handleError(error, _this.messages, 'Грешка! Моля, опитайте отново.', _this.props.history);
                }
                _this.resetForm();
                _this.props.onHideSpinner();
            });
        };
        _this.resetForm = function () {
            var newFormConfig;
            newFormConfig = cloneDeep(loginSchema);
            _this.setState({ formConfig: newFormConfig });
        };
        // Sets up the template content dynamically
        _this.getTemplateContent = function () {
            _this.header = (React.createElement(React.Fragment, null,
                React.createElement("h1", null, "\u0412\u0445\u043E\u0434"),
                React.createElement("p", { className: "text-muted" }, "\u0412\u043B\u0435\u0437\u0442\u0435 \u0432 \u0430\u043A\u0430\u0443\u043D\u0442\u0430 \u0441\u0438.")));
            _this.submitButton = (React.createElement("button", { className: "btn btn-primary px-4", type: "submit", id: "loginUser", disabled: !_this.state.formIsValid }, "\u0412\u043F\u0438\u0441\u0432\u0430\u043D\u0435"));
        };
        return _this;
    }
    UnauthUser.prototype.componentDidMount = function () {
        this.location = this.props.location.pathname;
        // Removing the trailing slash
        if (this.location.substr(-1) === '/') {
            this.location = this.location.substr(0, this.location.length - 1);
        }
        this.setState({ formConfig: cloneDeep(loginSchema), formIsValid: true });
    };
    UnauthUser.prototype.render = function () {
        var _this = this;
        var formElementsArray = [];
        for (var key in this.state.formConfig) {
            if (this.state.formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: this.state.formConfig[key],
                    id: key,
                });
            }
        }
        var form = formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, changed: function (event) { return _this.inputChangedHandler(event, formElement, 'onChange'); }, addon: typeof formElement.config.addon !== 'undefined' ? formElement.config.addon : null, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, blur: formElement.config.validation.pattern
                    ? function (event) { return _this.inputBlurHandler(event, formElement.id); }
                    : null, maxLength: formElement.config.maxLength, wrapperClass: formElement.config.wrapperClass, labelExtraClass: formElement.config.labelExtraClass }));
        });
        this.getTemplateContent();
        return (React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row justify-content-center" },
                React.createElement("form", { className: "col-md-5 login-form", onSubmit: this.submitFormHandler },
                    React.createElement("div", { className: "card-group" },
                        React.createElement("div", { className: "card p-4" },
                            React.createElement("div", { className: "card-body" },
                                React.createElement(Messages, { ref: function (el) {
                                        _this.messages = el;
                                    } }),
                                this.header,
                                form,
                                React.createElement("div", { className: "row" },
                                    React.createElement("div", { className: 'col-6' }, this.submitButton)))))))));
    };
    return UnauthUser;
}(React.Component));
export default connect(null, UnauthUserReduxProps.mapDispatchToProps)(UnauthUser);



//////////////////
// WEBPACK FOOTER
// ./src/views/UnauthUser/UnauthUser.tsx
// module id = 626
// module chunks = 0